module.exports = __webpack_public_path__ + "static/media/Lateral_NES_Z1.711e3e1b.png";